module.exports = __webpack_public_path__ + "static/media/active_face.6ca15dbb.svg";